/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import React from "react";
import {
  getOverrideProps,
  useNavigateAction,
} from "@aws-amplify/ui-react/internal";
import { Button, Flex, Icon, View } from "@aws-amplify/ui-react";
export default function NavBar(props) {
  const { overrides, ...rest } = props;
  const joinUsOnClick = useNavigateAction({
    target: "_blank",
    type: "url",
    url: "https://angel.co/company/tamarind-2",
  });
  const pricingOnClick = useNavigateAction({
    anchor: "pricing",
    type: "anchor",
  });
  const featuresOnClick = useNavigateAction({
    anchor: "features",
    type: "anchor",
  });
  const buttonOnClick = useNavigateAction({
    target: "_blank",
    type: "url",
    url: "/contact",
  });
  const logoOnClick = useNavigateAction({ type: "url", url: "." });
  return (
    <Flex
      gap="20px"
      width="1440px"
      height="96px"
      justifyContent="center"
      alignItems="center"
      position="relative"
      padding="24px 32px 24px 32px"
      backgroundColor="rgba(255,255,255,1)"
      {...rest}
      {...getOverrideProps(overrides, "NavBar")}
    >
      <Flex
        padding="0px 0px 0px 0px"
        width="1285px"
        height="41.88px"
        shrink="0"
        position="relative"
        {...getOverrideProps(overrides, "Group 28")}
      >
        <View
          padding="0px 0px 0px 0px"
          width="258px"
          height="33.5px"
          position="absolute"
          top="0px"
          left="738.5px"
          {...getOverrideProps(overrides, "Options")}
        >
          <Button
            display="flex"
            gap="0"
            position="absolute"
            top="0px"
            left="183px"
            justifyContent="center"
            alignItems="center"
            size="small"
            isDisabled={false}
            variation="link"
            children="Join Us"
            onClick={() => {
              joinUsOnClick();
            }}
            {...getOverrideProps(overrides, "Join Us")}
          ></Button>
          <Button
            display="flex"
            gap="0"
            position="absolute"
            top="0px"
            left="97px"
            justifyContent="center"
            alignItems="center"
            size="small"
            isDisabled={false}
            variation="link"
            children="Pricing"
            onClick={() => {
              pricingOnClick();
            }}
            {...getOverrideProps(overrides, "Pricing")}
          ></Button>
          <Button
            display="flex"
            gap="0"
            position="absolute"
            top="0.5px"
            left="0px"
            justifyContent="center"
            alignItems="center"
            size="small"
            isDisabled={false}
            variation="link"
            children="Features"
            onClick={() => {
              featuresOnClick();
            }}
            {...getOverrideProps(overrides, "Features")}
          ></Button>
        </View>
        <Button
          display="flex"
          gap="0"
          position="absolute"
          top="1.88px"
          left="1135px"
          width="150px"
          height="40px"
          justifyContent="center"
          alignItems="center"
          size="default"
          isDisabled={false}
          variation="primary"
          children="Get Started"
          onClick={() => {
            buttonOnClick();
          }}
          {...getOverrideProps(overrides, "Button")}
        ></Button>
        <View
          padding="0px 0px 0px 0px"
          width="203.21px"
          height="40px"
          position="absolute"
          top="1.88px"
          left="0px"
          onClick={() => {
            logoOnClick();
          }}
          {...getOverrideProps(overrides, "Logo")}
        >
          <View
            width="40px"
            height="40px"
            position="absolute"
            top="0px"
            left="0px"
            overflow="hidden"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "logo_800px")}
          >
            <Icon
              width="40px"
              height="40px"
              viewBox={{ minX: 0, minY: 0, width: 40, height: 40 }}
              paths={[
                {
                  d: "M32.5 0L7.5 0C3.35786 0 0 3.35786 0 7.5L0 32.5C0 36.6421 3.35786 40 7.5 40L32.5 40C36.6421 40 40 36.6421 40 32.5L40 7.5C40 3.35786 36.6421 0 32.5 0Z",
                  fill: "rgba(207,109,38,1)",
                  fillRule: "nonzero",
                },
              ]}
              position="absolute"
              top="0%"
              bottom="0%"
              left="0%"
              right="0%"
              {...getOverrideProps(overrides, "Vector32092716")}
            ></Icon>
            <Icon
              width="4.14990234375px"
              height="11.7001953125px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.14990234375,
                height: 11.7001953125,
              }}
              paths={[
                {
                  d: "M11.7 0L0 0L0 4.15L11.7 4.15L11.7 0Z",
                  fill: "rgba(250,250,250,1)",
                  fillRule: "nonzero",
                },
              ]}
              position="absolute"
              top="76.5%"
              bottom="13.13%"
              left="44.75%"
              right="26%"
              transformOrigin="top left"
              transform="rotate(-90deg)"
              {...getOverrideProps(overrides, "Vector32092717")}
            ></Icon>
            <Icon
              width="19.199951171875px"
              height="4.10009765625px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 19.199951171875,
                height: 4.10009765625,
              }}
              paths={[
                {
                  d: "M19.2 0L0 0L0 4.1L19.2 4.1L19.2 0Z",
                  fill: "rgba(250,250,250,1)",
                  fillRule: "nonzero",
                },
              ]}
              position="absolute"
              top="31.25%"
              bottom="58.5%"
              left="26%"
              right="26%"
              {...getOverrideProps(overrides, "Vector32092718")}
            ></Icon>
          </View>
          <Icon
            width="139.21484375px"
            height="24px"
            viewBox={{ minX: 0, minY: 0, width: 139.21484375, height: 24 }}
            paths={[
              {
                d: "M11.4139 1.23393L11.4139 23.6915L6.80206 23.6915L6.80206 1.23393L11.4139 1.23393ZM18.324 1.23393L18.324 4.85861L0 4.85861L0 1.23393L18.324 1.23393ZM28.4526 19.9281L28.4526 12.4936C28.4526 11.9589 28.3653 11.5013 28.1904 11.1208C28.0157 10.7301 27.7431 10.4267 27.3729 10.2108C27.0131 9.99486 26.5453 9.8869 25.9694 9.8869C25.4758 9.8869 25.0491 9.97429 24.6891 10.1491C24.3293 10.3136 24.0517 10.5553 23.8563 10.8741C23.6609 11.1825 23.5631 11.5476 23.5631 11.9692L19.121 11.9692C19.121 11.2597 19.2856 10.5861 19.6146 9.9486C19.9437 9.31106 20.4218 8.75064 21.049 8.26737C21.6763 7.77379 22.4218 7.38817 23.2856 7.11054C24.1595 6.83291 25.1364 6.69409 26.2161 6.69409C27.5117 6.69409 28.6635 6.91003 29.6711 7.34191C30.6788 7.77379 31.4707 8.4216 32.0465 9.28536C32.6326 10.1491 32.9257 11.2288 32.9257 12.5244L32.9257 19.6659C32.9257 20.581 32.9823 21.3317 33.0954 21.9178C33.2084 22.4935 33.373 22.9974 33.5889 23.4293L33.5889 23.6915L29.1005 23.6915C28.8846 23.239 28.72 22.6736 28.6069 21.9949C28.5041 21.306 28.4526 20.617 28.4526 19.9281ZM29.0387 13.527L29.0697 16.0411L26.5863 16.0411C26.0002 16.0411 25.4912 16.108 25.0593 16.2417C24.6275 16.3753 24.2728 16.5656 23.9951 16.8123C23.7175 17.0489 23.5118 17.3266 23.3782 17.6453C23.2547 17.964 23.1931 18.3137 23.1931 18.694C23.1931 19.0745 23.2804 19.419 23.4553 19.7275C23.6301 20.0257 23.882 20.2623 24.211 20.4371C24.54 20.6015 24.9257 20.6838 25.3678 20.6838C26.0362 20.6838 26.6171 20.5502 27.1107 20.2828C27.6043 20.0154 27.9848 19.6864 28.2522 19.2957C28.5298 18.9049 28.6737 18.5347 28.684 18.1851L29.8562 20.0669C29.6917 20.4884 29.4655 20.9255 29.1776 21.378C28.8999 21.8303 28.5452 22.2571 28.1133 22.6581C27.6815 23.0489 27.1622 23.3728 26.5555 23.6298C25.9489 23.8766 25.229 24 24.3961 24C23.337 24 22.3756 23.7891 21.5118 23.3676C20.6582 22.9358 19.9797 22.3444 19.4757 21.5939C18.9821 20.8329 18.7354 19.9691 18.7354 19.0025C18.7354 18.1286 18.9 17.3522 19.229 16.6735C19.558 15.9949 20.0413 15.4242 20.6789 14.9615C21.3267 14.4884 22.1339 14.1337 23.1005 13.8972C24.0671 13.6504 25.1879 13.527 26.463 13.527L29.0387 13.527ZM41.8975 10.4576L41.8975 23.6915L37.4401 23.6915L37.4401 7.00257L41.62 7.00257L41.8975 10.4576ZM41.2806 14.7609L40.0468 14.7609C40.0468 13.599 40.1856 12.5296 40.4631 11.5527C40.751 10.5656 41.1675 9.71209 41.7126 8.9923C42.2678 8.26222 42.9517 7.69667 43.764 7.29563C44.5763 6.8946 45.5171 6.69409 46.5866 6.69409C47.3269 6.69409 48.0055 6.80721 48.6226 7.03342C49.2396 7.24936 49.7691 7.59383 50.2112 8.06684C50.6637 8.52957 51.0133 9.13626 51.2601 9.8869C51.5068 10.6273 51.6304 11.5167 51.6304 12.5553L51.6304 23.6915L47.1882 23.6915L47.1882 13.0489C47.1882 12.2879 47.0852 11.7018 46.8796 11.2905C46.6739 10.8792 46.3809 10.5913 46.0005 10.4267C45.6302 10.2622 45.1829 10.18 44.6586 10.18C44.0827 10.18 43.5789 10.2982 43.147 10.5347C42.7253 10.7712 42.3758 11.1003 42.0981 11.5219C41.8205 11.9332 41.6148 12.4165 41.4812 12.9717C41.3474 13.527 41.2806 14.1234 41.2806 14.7609ZM51.2139 14.2519L49.6251 14.4525C49.6251 13.3625 49.7589 12.3496 50.0261 11.4139C50.3038 10.4782 50.71 9.65553 51.2447 8.94602C51.7897 8.2365 52.4632 7.68639 53.2652 7.29563C54.0673 6.8946 54.9928 6.69409 56.0416 6.69409C56.8436 6.69409 57.5738 6.81234 58.2318 7.04885C58.8899 7.27507 59.4503 7.64011 59.9131 8.14397C60.3861 8.63754 60.7459 9.28536 60.9928 10.0874C61.2497 10.8895 61.3783 11.8715 61.3783 13.0334L61.3783 23.6915L56.9208 23.6915L56.9208 13.0334C56.9208 12.2622 56.818 11.6761 56.6122 11.2751C56.417 10.8638 56.1291 10.581 55.7486 10.4267C55.3783 10.2622 54.9363 10.18 54.422 10.18C53.8874 10.18 53.4195 10.2879 53.0185 10.5039C52.6175 10.7095 52.2833 10.9974 52.0159 11.3676C51.7485 11.7378 51.5481 12.1697 51.4143 12.6633C51.2807 13.1465 51.2139 13.6761 51.2139 14.2519ZM74.9313 19.9281L74.9313 12.4936C74.9313 11.9589 74.8438 11.5013 74.6691 11.1208C74.4943 10.7301 74.2218 10.4267 73.8516 10.2108C73.4916 9.99486 73.0238 9.8869 72.4479 9.8869C71.9544 9.8869 71.5276 9.97429 71.1678 10.1491C70.8079 10.3136 70.5302 10.5553 70.3348 10.8741C70.1394 11.1825 70.0418 11.5476 70.0418 11.9692L65.5997 11.9692C65.5997 11.2597 65.7641 10.5861 66.0932 9.9486C66.4222 9.31106 66.9005 8.75064 67.5277 8.26737C68.1549 7.77379 68.9004 7.38817 69.7642 7.11054C70.6382 6.83291 71.6151 6.69409 72.6948 6.69409C73.9904 6.69409 75.142 6.91003 76.1498 7.34191C77.1575 7.77379 77.9493 8.4216 78.5251 9.28536C79.1113 10.1491 79.4043 11.2288 79.4043 12.5244L79.4043 19.6659C79.4043 20.581 79.4608 21.3317 79.5739 21.9178C79.6871 22.4935 79.8516 22.9974 80.0675 23.4293L80.0675 23.6915L75.579 23.6915C75.3631 23.239 75.1987 22.6736 75.0854 21.9949C74.9826 21.306 74.9313 20.617 74.9313 19.9281ZM75.5174 13.527L75.5482 16.0411L73.0649 16.0411C72.4789 16.0411 71.9698 16.108 71.5379 16.2417C71.1061 16.3753 70.7513 16.5656 70.4737 16.8123C70.196 17.0489 69.9903 17.3266 69.8567 17.6453C69.7334 17.964 69.6716 18.3137 69.6716 18.694C69.6716 19.0745 69.759 19.419 69.9338 19.7275C70.1086 20.0257 70.3606 20.2623 70.6896 20.4371C71.0187 20.6015 71.4043 20.6838 71.8465 20.6838C72.5148 20.6838 73.0958 20.5502 73.5894 20.2828C74.083 20.0154 74.4635 19.6864 74.7307 19.2957C75.0084 18.9049 75.1524 18.5347 75.1627 18.1851L76.3349 20.0669C76.1704 20.4884 75.9442 20.9255 75.6563 21.378C75.3786 21.8303 75.0238 22.2571 74.5919 22.6581C74.1601 23.0489 73.6407 23.3728 73.0341 23.6298C72.4274 23.8766 71.7077 24 70.8747 24C69.8157 24 68.8541 23.7891 67.9905 23.3676C67.1369 22.9358 66.4583 22.3444 65.9544 21.5939C65.4608 20.8329 65.214 19.9691 65.214 19.0025C65.214 18.1286 65.3785 17.3522 65.7076 16.6735C66.0367 15.9949 66.52 15.4242 67.1575 14.9615C67.8054 14.4884 68.6124 14.1337 69.5791 13.8972C70.5457 13.6504 71.6664 13.527 72.9415 13.527L75.5174 13.527ZM88.3762 10.6427L88.3762 23.6915L83.9341 23.6915L83.9341 7.00257L88.1141 7.00257L88.3762 10.6427ZM93.4045 6.8946L93.3275 11.0129C93.1114 10.982 92.8492 10.9563 92.5407 10.9357C92.2425 10.9049 91.9701 10.8895 91.7232 10.8895C91.096 10.8895 90.551 10.9717 90.0883 11.1363C89.6358 11.2905 89.2554 11.5219 88.9469 11.8303C88.6487 12.1388 88.4225 12.5142 88.2682 12.9563C88.1243 13.3985 88.042 13.9023 88.0215 14.4679L87.1269 14.1903C87.1269 13.1105 87.2348 12.1183 87.4507 11.2134C87.6668 10.2982 87.9803 9.50128 88.3917 8.82263C88.8133 8.14396 89.3274 7.61955 89.934 7.24936C90.5407 6.87918 91.2349 6.69409 92.0164 6.69409C92.2631 6.69409 92.515 6.71465 92.7721 6.75578C93.0293 6.78665 93.24 6.83291 93.4045 6.8946ZM101.297 7.00257L101.297 23.6915L96.8392 23.6915L96.8392 7.00257L101.297 7.00257ZM96.5615 2.65296C96.5615 2.00514 96.7877 1.47044 97.2402 1.04884C97.6927 0.627249 98.2994 0.416453 99.0602 0.416453C99.8109 0.416453 100.412 0.627249 100.865 1.04884C101.328 1.47044 101.559 2.00514 101.559 2.65296C101.559 3.30077 101.328 3.83549 100.865 4.25707C100.412 4.67867 99.8109 4.88946 99.0602 4.88946C98.2994 4.88946 97.6927 4.67867 97.2402 4.25707C96.7877 3.83549 96.5615 3.30077 96.5615 2.65296ZM110.423 10.5656L110.423 23.6915L105.981 23.6915L105.981 7.00257L110.145 7.00257L110.423 10.5656ZM109.775 14.7609L108.572 14.7609C108.572 13.527 108.731 12.4165 109.05 11.4293C109.369 10.4319 109.816 9.58356 110.392 8.88433C110.968 8.17481 111.652 7.63496 112.444 7.26479C113.246 6.88432 114.14 6.69409 115.127 6.69409C115.909 6.69409 116.624 6.80721 117.271 7.03342C117.919 7.25964 118.474 7.61955 118.937 8.11312C119.41 8.60669 119.77 9.25965 120.017 10.072C120.274 10.8843 120.402 11.8766 120.402 13.0489L120.402 23.6915L115.929 23.6915L115.929 13.0334C115.929 12.2931 115.827 11.7172 115.621 11.3059C115.415 10.8946 115.112 10.6067 114.711 10.4422C114.32 10.2674 113.837 10.18 113.261 10.18C112.664 10.18 112.145 10.2982 111.703 10.5347C111.271 10.7712 110.911 11.1003 110.623 11.5219C110.346 11.9332 110.135 12.4165 109.991 12.9717C109.847 13.527 109.775 14.1234 109.775 14.7609ZM134.742 20.0514L134.742 0L139.215 0L139.215 23.6915L135.189 23.6915L134.742 20.0514ZM124.192 15.5476L124.192 15.2237C124.192 13.9486 124.336 12.7918 124.624 11.7532C124.912 10.7044 125.333 9.80463 125.888 9.05399C126.444 8.30335 127.128 7.72237 127.94 7.31107C128.752 6.89975 129.678 6.69409 130.716 6.69409C131.693 6.69409 132.547 6.89975 133.277 7.31107C134.017 7.72237 134.644 8.30849 135.158 9.06942C135.683 9.82006 136.104 10.7095 136.423 11.7378C136.742 12.7558 136.973 13.8715 137.117 15.0848L137.117 15.7944C136.973 16.9563 136.742 18.0361 136.423 19.0335C136.104 20.0309 135.683 20.9049 135.158 21.6555C134.644 22.3959 134.017 22.9718 133.277 23.3831C132.536 23.7944 131.673 24 130.685 24C129.647 24 128.721 23.7891 127.909 23.3676C127.107 22.946 126.428 22.3547 125.873 21.5939C125.328 20.8329 124.912 19.9383 124.624 18.9101C124.336 17.8817 124.192 16.761 124.192 15.5476ZM128.634 15.2237L128.634 15.5476C128.634 16.2364 128.685 16.8791 128.788 17.4757C128.901 18.0721 129.081 18.6015 129.328 19.0643C129.585 19.5168 129.914 19.8715 130.315 20.1285C130.726 20.3754 131.225 20.4987 131.811 20.4987C132.572 20.4987 133.2 20.3291 133.693 19.9897C134.187 19.6401 134.562 19.162 134.819 18.5552C135.086 17.9485 135.241 17.2493 135.282 16.4576L135.282 14.437C135.251 13.7892 135.158 13.2082 135.004 12.6941C134.86 12.1697 134.644 11.7224 134.356 11.3522C134.079 10.982 133.729 10.6941 133.307 10.4884C132.896 10.2828 132.408 10.18 131.842 10.18C131.266 10.18 130.773 10.3136 130.361 10.581C129.95 10.8381 129.616 11.1928 129.359 11.6453C129.112 12.0977 128.927 12.6324 128.804 13.2494C128.691 13.8561 128.634 14.5141 128.634 15.2237Z",
                fill: "rgba(207,109,38,1)",
                fillRule: "nonzero",
              },
            ]}
            position="absolute"
            top="20%"
            bottom="20%"
            left="31.49%"
            right="0%"
            {...getOverrideProps(overrides, "Vector32092719")}
          ></Icon>
        </View>
      </Flex>
    </Flex>
  );
}
